/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('../../normalize-component-d885d5ff.js');
var vuex_esmBundler = require('../../vuex.esm-bundler-607ad4c2.js');
var base = require('../../base-cc3cef3f.js');
var toString = require('../../to-string-e5a81da9.js');
var regexpExecAbstract = require('../../regexp-exec-abstract-6e247220.js');
require('vue');
require('../../index-1651dbe5.js');
require('../../index-5d056502.js');
require('../../es.number.constructor-17a0e7eb.js');
require('../../themeContent-f8df7540.js');

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toString.toStringTagSupport ? {}.toString : function toString$1() {
  return '[object ' + toString.classof(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!toString.toStringTagSupport) {
  toString.defineBuiltIn(Object.prototype, 'toString', objectToString, { unsafe: true });
}

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor = function (argument) {
  if (base.isConstructor(argument)) return argument;
  throw $TypeError(normalizeComponent.tryToString(argument) + ' is not a constructor');
};

var SPECIES = normalizeComponent.wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = normalizeComponent.anObject(O).constructor;
  var S;
  return C === undefined || normalizeComponent.isNullOrUndefined(S = normalizeComponent.anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};

var createProperty = function (object, key, value) {
  var propertyKey = normalizeComponent.toPropertyKey(key);
  if (propertyKey in object) normalizeComponent.objectDefineProperty.f(object, propertyKey, toString.createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var $Array = Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = toString.lengthOfArrayLike(O);
  var k = toString.toAbsoluteIndex(start, length);
  var fin = toString.toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var UNSUPPORTED_Y = regexpExecAbstract.regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = normalizeComponent.functionUncurryThis(/./.exec);
var push = normalizeComponent.functionUncurryThis($push);
var stringSlice = normalizeComponent.functionUncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !normalizeComponent.fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
regexpExecAbstract.fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString.toString_1(normalizeComponent.requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!base.isRegexp(separator)) {
        return normalizeComponent.functionCall(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = normalizeComponent.functionCall(regexpExecAbstract.regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) base.functionApply($push, output, arraySliceSimple(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : normalizeComponent.functionCall(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = normalizeComponent.requireObjectCoercible(this);
      var splitter = normalizeComponent.isNullOrUndefined(separator) ? undefined : normalizeComponent.getMethod(separator, SPLIT);
      return splitter
        ? normalizeComponent.functionCall(splitter, separator, O, limit)
        : normalizeComponent.functionCall(internalSplit, toString.toString_1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = normalizeComponent.anObject(this);
      var S = toString.toString_1(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract.regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regexpExecAbstract.regexpExecAbstract(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toString.toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = base.advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

var script = {
  name: 'HeaderNuxt',
  extends: base.__vue_component__,
  data: function data() {
    return {
      isMedia: false
    };
  },
  watch: {
    isLogin: function isLogin(n, o) {
      this.userIsOpen();
      if (n) {
        this.$store.dispatch('getUserSafeInfo');
        this.showVipLevelAction();
      }
    },
    currency: function currency() {
      var cur = this.$cookie.get('current');
      if (cur) {
        this.$store.commit('CURRENT_CURRENCY', this.currency[cur]);
      }
    },
    $route: {
      handler: function handler(n) {
        if (this.$route.path.includes('academy')) {
          this.langs = [{
            code: 'en',
            name: 'English'
          },
          // {code: 'kr', name: '한국어', cursor: 'cursors'},
          {
            code: 'ru',
            name: 'Русский',
            cursor: 'cursors'
          }, {
            code: 'pt-br',
            name: 'Português (Brasil)',
            cursor: 'cursors'
          }
          // { code: 'jp', name: '日本語' },
          // {code: 'hk', name: '繁體中文', cursor: 'cursors'}
          ];
        } else {
          this.langs = [{
            code: 'en',
            name: 'English'
          },
          // {code: 'kr', name: '한국어'},
          {
            code: 'ru',
            name: 'Русский'
          }, {
            code: 'pt-br',
            name: 'Português (Brasil)'
          }
          // { code: 'jp', name: '日本語' },
          // {code: 'hk', name: '繁體中文'}
          ];
        }

        if (n.name && ['locale-Capital', 'locale-turbo', 'locale-advanced-market', 'locale-vulnerability', 'locale-loanTerms'].some(function (name) {
          return n.name.includes(name);
        })) {
          this.isMedia = true;
        } else {
          this.isMedia = false;
        }
      },
      immediate: true
    }
  },
  created: function created() {
    this.getCurrencies();
  },
  mounted: function mounted() {
    this.userIsOpen();
    this.$store.dispatch('checkLogin');
    this.spotSymbol = window.sessionStorage.getItem('spotSymbol') || '';
    this.perpetualSymbol = window.sessionStorage.getItem('perpetualSymbol') || '';
    this.isLogin && this.showVipLevelAction();
  },
  methods: vuex_esmBundler._objectSpread2(vuex_esmBundler._objectSpread2({}, vuex_esmBundler.mapActions(['doLogout', 'getCurrencies'])), {}, {
    userIsOpen: function userIsOpen() {
      var _this = this;
      return vuex_esmBundler._asyncToGenerator( /*#__PURE__*/vuex_esmBundler._regeneratorRuntime().mark(function _callee() {
        var res;
        return vuex_esmBundler._regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$axios.$get('/loans/loanCryptoCoin/userIsOpen');
            case 2:
              res = _context.sent;
              if (res.success) {
                _this.userIsOpenTrue = res.data;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setLang: function setLang(base) {
      this.languageClict = false;
      this.menuTrue = false;
      if (!this.$route.path.includes('academy')) {
        var path = this.$route.path.split('/' + this.locale)[1] || '';
        this.$router.push('/' + base + path);
        this.$cookie.set('lang', base);
      }
    },
    setCurrey: function setCurrey(base, index) {
      this.currencyClict = false;
      this.languageClict = false;
      this.menuTrue = false;
      this.$cookie.set('current', index);
      this.$store.commit('CURRENT_CURRENCY', base);
    },
    logout: function logout() {
      this.doLogout();
    }
  }),
  beforeDestroy: function beforeDestroy() {}
};

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

module.exports = __vue_component__;
